import type { SelectableFixture } from "@slot/game-shell";
import { FIXTURES, type FixtureId } from "./fixtures";

/**
 * The rounds the dev tools select by id: the hook's `loadFixture(id)` (the e2e suite), the dev menu's playlist,
 * `?fixtures=`. Ids are the fixture scripts' keys; the order and the groups are the dev menu's.
 */
const ENTRIES: readonly [FixtureId, string, string][] = [
  ["reel_no_win", "No win", "Base"],
  ["reel_anticipation", "Anticipation tease, no win", "Base"],
  ["reel_line_win", "One line (H4 × 3)", "Lines"],
  ["reel_three_wins", "Three separate lines", "Lines"],
  ["reel_grouped_win", "Two lines sharing cells", "Lines"],
  ["reel_zigzag", "Zigzag line (H1 × 5)", "Lines"],
  ["reel_wild_win", "Wild in a line", "Lines"],
  ["reel_vs_battle", "VS battle (× 3)", "VS"],
  ["reel_vs_double", "Two VS battles, summed", "VS"],
  ["reel_vs_no_battle", "VS with no battle", "VS"],
  ["reel_nice_win", "Nice win (24×)", "Big wins"],
  ["reel_big_win", "Big win up to epic (84×)", "Big wins"],
  ["reel_huge_win", "Big win up to huge (281×)", "Big wins"],
  ["fs_vs_rush", "VS Rush, natural trigger", "Free spins"],
  ["fs_super_bonus", "Super Bonus, natural trigger", "Free spins"],
  ["fs_retrigger", "VS Rush with a retrigger", "Free spins"],
  ["fs_capped", "Super Bonus reaching the max win", "Free spins"],
  ["buy_vs_rush", "VS Rush, bought", "Buys"],
  ["buy_super_bonus", "Super Bonus, bought", "Buys"],
  ["bonus_hunt_tease", "Bonus hunt tease", "Modes"],
  ["bonus_hunt_trigger", "Bonus hunt trigger", "Modes"],
  ["guaranteed_vs_battle", "Guaranteed VS, battle", "Modes"],
  ["guaranteed_vs_no_battle", "Guaranteed VS, no battle", "Modes"],
];

export const SELECTABLE_FIXTURES: readonly SelectableFixture[] = ENTRIES.map(([id, label, group]) => ({ id, label, group, create: FIXTURES[id] }));
